import React, { FC, useEffect } from "react";
import handleInstallPromotion from "../../configs/handleInstallPromotion";

const BannerPromotion: FC = () => {
  useEffect(() => {
    const installationBanner: HTMLElement | null = document.querySelector(".banner");
    const installButton: HTMLButtonElement | null = document.querySelector(".installBtn");
    const closeBtn: HTMLButtonElement | null = document.querySelector(".closeBtn");
    if (installationBanner && installButton && closeBtn)
      handleInstallPromotion(installationBanner, installButton, closeBtn);
  }, []);

  return (
    <div className="banner">
      <p>!سامانه مشترکین زیتل را نصب کنید</p>
      <div className="handler">
        <button className="closeBtn"> بعدا </button>
        <button className="installBtn">نصب</button>
      </div>
    </div>
  );
};

export default BannerPromotion;
